var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _dec87, _dec88, _dec89, _dec90, _dec91, _dec92, _dec93, _dec94, _dec95, _dec96, _dec97, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/* eslint-disable ember/no-assignment-of-untracked-properties-used-in-tracking-contexts */
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { equal, gt, mapBy, sort, filterBy } from '@ember/object/computed';
import { isNone, isPresent, isEmpty } from '@ember/utils';
import { A } from '@ember/array';
import { computed, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { fragmentArray, fragment, array } from 'ember-data-model-fragments/attributes';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
import Money from '@square/dashboard-money/models/money';
import Logger from '@square/dashboard-utilities/utils/logger';
import captureItemFeeMembershipConstraint from '@square/dashboard-utilities/utils/sentry/capture-item-fee-membership-constraint';
import { CATEGORY_TYPE } from '@square/dashboard-items-data/models/connect/category/data';
import { getOwner } from '@ember/application';
import { isListModifierType } from '@square/dashboard-items-data/utils/modifiers';
import { ItemType, ItemTypesForFiltering_V3 } from '@square/dashboard-items-data/utils/item-type-constants';
import { PricingType } from '@square/dashboard-items-data/models/item-variation';
import { assert } from '@ember/debug';
import environment from '@square/environment-utils/environment';
export const VisibilityType = NumericEnum.create(['PUBLIC', 'PRIVATE', 'PUBLIC_ONLY']);
export const EcomVisibility = NumericEnum.create(['DO_NOT_USE', 'UNINDEXED', 'UNAVAILABLE', 'HIDDEN', 'VISIBLE']);
const MAX_NAME_LENGTH = 255;
const MAX_SKU_LENGTH = 80;
export const MAX_ITEM_VARIATIONS = 250;
export const MAX_ITEM_OPTIONS_ON_ITEM = 6;
let Item = (_dec = attr('string'), _dec2 = belongsTo('age-restriction', {
  async: false
}), _dec3 = attr('boolean', {
  allowNull: true
}), _dec4 = attr('boolean', {
  allowNull: true
}), _dec5 = attr('boolean', {
  allowNull: true
}), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string-empty-to-null'), _dec13 = attr('boolean', {
  defaultValue: true
}), _dec14 = attr('enum', {
  enumClass: ItemType
}), _dec15 = attr('enum', {
  enumClass: VisibilityType,
  defaultValue: VisibilityType.PRIVATE
}), _dec16 = attr('number'), _dec17 = attr('boolean', {
  allowNull: true
}), _dec18 = attr('enum', {
  enumClass: EcomVisibility
}), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('string'), _dec22 = attr('string'), _dec23 = attr('string'), _dec24 = attr('string'), _dec25 = attr('string'), _dec26 = array('string', {
  defaultValue: []
}), _dec27 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec28 = hasMany('combo-slot', {
  async: false,
  inverse: null
}), _dec29 = fragmentArray('custom-attribute-value'), _dec30 = attr('string'), _dec31 = attr('string'), _dec32 = attr('string'), _dec33 = attr('string'), _dec34 = attr('string'), _dec35 = attr('boolean', {
  allowNull: true
}), _dec36 = attr('number', {
  allowNull: true
}), _dec37 = attr('boolean', {
  allowNull: true
}), _dec38 = attr('string', {
  allowNull: true
}), _dec39 = belongsTo('category', {
  async: false
}), _dec40 = fragmentArray('category-membership', {
  relatedType: 'connect/category'
}), _dec41 = hasMany('item-variation', {
  autosaved: ['itemVariationVendorInfos', 'components', 'composition', 'ingredients', 'recipe', 'salePrices'],
  async: false
}), _dec42 = fragment('online-store-item-data'), _dec43 = fragmentArray('object-image-membership', {
  relatedType: 'connect/image'
}), _dec44 = hasMany('item-item-modifier-list-membership', {
  async: false
}), _dec45 = hasMany('item-fee-membership', {
  async: false
}), _dec46 = hasMany('connect/item-option', {
  async: false
}), _dec47 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec48 = computed(), _dec49 = sort('imageMemberships', 'imageSortProperties'), _dec50 = mapBy('sortedImageMemberships', 'image'), _dec51 = computed('images.firstObject'), _dec52 = computed('images', 'sellableVariations.@each.images'), _dec53 = computed('itemItemModifierListMemberships.[]'), _dec54 = computed('type'), _dec55 = computed('type'), _dec56 = gt('actualItemVariations.length', 1), _dec57 = computed('taxable'), _dec58 = computed('ageRestriction.isDirty', 'comboSlots.@each.isDirty', 'dirtyType', 'hasDirtyFields', 'itemFeeMemberships.@each.isDirty', 'itemItemModifierListMemberships.@each.isDirty', 'itemVariations.@each.isDirty', 'menuCategory.isDirty'), _dec59 = computed('additionalCategories.[]', {
  get() {
    return this.additionalCategories.filter(categoryMembership => {
      const category = categoryMembership.category;
      return category?.categoryType === CATEGORY_TYPE.KITCHEN_CATEGORY;
    });
  }
}), _dec60 = computed('ecomVisibility', 'ecomAvailable', {
  get() {
    switch (this.ecomVisibility) {
      case EcomVisibility.UNINDEXED:
      case EcomVisibility.UNAVAILABLE:
        return false;
      case EcomVisibility.HIDDEN:
      case EcomVisibility.VISIBLE:
        return true;
      default:
        // Return a bool, not null.
        return Boolean(this.ecomAvailable);
    }
  },
  set(key, value) {
    this.ecomAvailable = value;
    if (value) {
      if (this.ecomVisibility !== EcomVisibility.VISIBLE) {
        this.ecomVisibility = EcomVisibility.HIDDEN;
      }
    } else {
      this.ecomVisibility = EcomVisibility.UNAVAILABLE;
    }
    return value;
  }
}), _dec61 = equal('actualItemVariations.length', 1), _dec62 = computed('actualItemVariations.[]', 'intl'), _dec63 = computed('itemItemModifierListMemberships.@each.{actualItemModifierOptionNames,enabled,modifierListFormattedName,modifierListSubunitTokens}'), _dec64 = computed('itemItemModifierListMemberships.@each.{actualItemModifierOptionNames,enabled,modifierListFormattedName,modifierListSubunitTokens,modifierListType,modifierList}'), _dec65 = mapBy('actualItemVariations', 'merchantCustomAttributeDefinitions'), _dec66 = computed('variationMerchantCustomAttributeDefinitionArrays.@each.length'), _dec67 = computed('subunits.@each.token', 'actualItemVariations.@each.unitOverrides'), _dec68 = computed('itemVariations.@each.{isDeleted,isPlaceholder,ordinal,stockable}', 'userSubscriptions.{canUseAdvancedInventory,canUseRecipes}'), _dec69 = computed('nonDeletedNonPlaceholderVariations.@each.derivedSellByVariations'), _dec70 = computed('nonDeletedNonPlaceholderVariations.@each.{ordinal,sellable}'), _dec71 = filterBy('nonDeletedNonPlaceholderVariations', 'isNotForSale'), _dec72 = computed('nonDeletedNonPlaceholderVariations.@each.{component,composition}'), _dec73 = computed('nonDeletedNonPlaceholderVariations.[]', 'componentInventoryVariations.[]'), _dec74 = computed('stockByVariations.[]'), _dec75 = computed('_actualItemVariations', 'features', 'nonComponentInventoryVariations.[]', 'nonDeletedNonPlaceholderVariations.firstObject.recipe.isDeleted', 'stockByVariations.[]', 'userSubscriptions.{canUseAdvancedInventory,canUseRecipes}', {
  get() {
    if (this._actualItemVariations !== undefined) {
      return this._actualItemVariations;
    }
    // we need to check if the recipe has been loaded before the secondary check
    // or else anything that uses actualItemVariations will need to make sure it loads the recipe first
    if (this.userSubscriptions.canUseRecipes && this.nonDeletedNonPlaceholderVariations.firstObject?.belongsTo('recipe').value() !== null) {
      if (!isEmpty(this.nonDeletedNonPlaceholderVariations.firstObject?.recipe) && this.nonDeletedNonPlaceholderVariations.firstObject?.recipe.isDeleted !== true) {
        return this.nonDeletedNonPlaceholderVariations;
      }
    }
    if (this.userSubscriptions.canUseAdvancedInventory) {
      return [...this.stockByVariations, ...this.nonComponentInventoryVariations];
    }
    return this.nonDeletedNonPlaceholderVariations;
  },
  set(_, value) {
    return this._actualItemVariations = value;
  }
}), _dec76 = computed('actualItemVariations.@each.price', 'type'), _dec77 = computed('actualItemVariations'), _dec78 = computed('actualItemVariations.@each.unitOverrides'), _dec79 = computed('actualItemVariations.firstObject.recipe', 'userSubscriptions.canUseRecipes'), _dec80 = computed('itemFeeMemberships.@each.{fee,isDeleted}', 'store'), _dec81 = computed('itemItemModifierListMemberships', 'features'), _dec82 = computed('_displayAbbreviation', 'abbreviation', 'name'), _dec83 = computed('sellableVariations.[]', 'itemVariations.@each.priceRange', 'intl'), _dec84 = computed('sellableVariations.[]', 'itemVariations.@each.priceRange', 'intl'), _dec85 = computed('sellableVariations.@each.{pricingType,measurementUnit,price}', 'subunits'), _dec86 = computed('itemOptions.[]', 'itemVariations.@each.{isDeleted,itemOptionValuesByOptionId}'), _dec87 = computed('itemOptions.@each.{id,values}', 'variationOptionValuesByOptionId'), _dec88 = computed('itemOptions.@each.{id,tempId}', 'variationOptionValuesByOptionId'), _dec89 = computed('actualItemVariations'), _dec90 = computed('actualItemVariations', 'userSubscriptions.canUseRecipes'), _dec91 = computed('type'), _dec92 = computed('type'), _dec93 = attr('number'), _dec94 = fragmentArray('food-and-bev-ingredients'), _dec95 = computed('foodAndBevIngredients'), _dec96 = fragmentArray('food-and-bev-dietary-preferences'), _dec97 = computed('foodAndBevDietaryPreferences'), (_class = (_class2 = class Item extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isItem", true);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "abbreviation", _descriptor5, this);
    _initializerDefineProperty(this, "ageRestriction", _descriptor6, this);
    _initializerDefineProperty(this, "availableOnline", _descriptor7, this);
    _initializerDefineProperty(this, "availableForPickup", _descriptor8, this);
    _initializerDefineProperty(this, "availableElectronically", _descriptor9, this);
    _initializerDefineProperty(this, "buyerFacingName", _descriptor10, this);
    _initializerDefineProperty(this, "color", _descriptor11, this);
    _initializerDefineProperty(this, "description", _descriptor12, this);
    _initializerDefineProperty(this, "htmlDescription", _descriptor13, this);
    _initializerDefineProperty(this, "name", _descriptor14, this);
    _initializerDefineProperty(this, "sortName", _descriptor15, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor16, this);
    _initializerDefineProperty(this, "taxable", _descriptor17, this);
    _initializerDefineProperty(this, "type", _descriptor18, this);
    _initializerDefineProperty(this, "visibility", _descriptor19, this);
    _initializerDefineProperty(this, "ordinal", _descriptor20, this);
    _initializerDefineProperty(this, "ecomAvailable", _descriptor21, this);
    _initializerDefineProperty(this, "ecomVisibility", _descriptor22, this);
    _initializerDefineProperty(this, "ecomSeoPermalink", _descriptor23, this);
    _initializerDefineProperty(this, "ecomSeoPageTitle", _descriptor24, this);
    _initializerDefineProperty(this, "ecomSeoPageDescription", _descriptor25, this);
    _initializerDefineProperty(this, "openGraphLinkTitle", _descriptor26, this);
    _initializerDefineProperty(this, "openGraphLinkDescription", _descriptor27, this);
    _initializerDefineProperty(this, "ecomBuyButtonText", _descriptor28, this);
    _initializerDefineProperty(this, "ecomUri", _descriptor29, this);
    _initializerDefineProperty(this, "channels", _descriptor30, this);
    _initializerDefineProperty(this, "skipsModifierScreen", _descriptor31, this);
    _initializerDefineProperty(this, "comboSlots", _descriptor32, this);
    _initializerDefineProperty(this, "customAttributes", _descriptor33, this);
    // -----------------------------------------------
    // These ids are in the process of being deprecated for SQ Items, and should not be used to look up Fulfillment Preferences.
    // Call the FP API using the item id instead.
    _initializerDefineProperty(this, "shippingFulfillmentPreferencesId", _descriptor34, this);
    _initializerDefineProperty(this, "pickupFulfillmentPreferencesId", _descriptor35, this);
    _initializerDefineProperty(this, "deliveryFulfillmentPreferencesId", _descriptor36, this);
    _initializerDefineProperty(this, "dineInFulfillmentPreferencesId", _descriptor37, this);
    // -----------------------------------------------
    _initializerDefineProperty(this, "posDisplayName", _descriptor38, this);
    _initializerDefineProperty(this, "ecomAllowOrderItemQuantities", _descriptor39, this);
    _initializerDefineProperty(this, "ecomOrderItemMaxQuantity", _descriptor40, this);
    _initializerDefineProperty(this, "requiresSubscriptionToSell", _descriptor41, this);
    _initializerDefineProperty(this, "customShippingBoxId", _descriptor42, this);
    _initializerDefineProperty(this, "menuCategory", _descriptor43, this);
    _initializerDefineProperty(this, "additionalCategories", _descriptor44, this);
    _initializerDefineProperty(this, "itemVariations", _descriptor45, this);
    _initializerDefineProperty(this, "onlineStoreItemData", _descriptor46, this);
    _initializerDefineProperty(this, "imageMemberships", _descriptor47, this);
    _initializerDefineProperty(this, "itemItemModifierListMemberships", _descriptor48, this);
    _initializerDefineProperty(this, "itemFeeMemberships", _descriptor49, this);
    _initializerDefineProperty(this, "itemOptions", _descriptor50, this);
    _initializerDefineProperty(this, "isArchived", _descriptor51, this);
    _initializerDefineProperty(this, "sortedImageMemberships", _descriptor52, this);
    _initializerDefineProperty(this, "images", _descriptor53, this);
    _initializerDefineProperty(this, "hasMultipleVariations", _descriptor54, this);
    _initializerDefineProperty(this, "kitchenCategories", _descriptor55, this);
    _initializerDefineProperty(this, "isAvailableOnline", _descriptor56, this);
    _initializerDefineProperty(this, "isSinglePriced", _descriptor57, this);
    _initializerDefineProperty(this, "variationMerchantCustomAttributeDefinitionArrays", _descriptor58, this);
    /**
     * Does not include variations with component inventory
     */
    _initializerDefineProperty(this, "notForSaleVariations", _descriptor59, this);
    _initializerDefineProperty(this, "actualItemVariations", _descriptor60, this);
    _initializerDefineProperty(this, "foodAndBevCalorieCount", _descriptor61, this);
    _initializerDefineProperty(this, "foodAndBevIngredients", _descriptor62, this);
    _initializerDefineProperty(this, "foodAndBevDietaryPreferences", _descriptor63, this);
  }
  static createDefault(store, merchantSubunits, options) {
    const application = getOwner(store);
    const userInfo = application.lookup('service:user-info');
    const itemType = options?.type;
    function getDefaultTaxableValueForItemType(countryCode, itemType) {
      switch (countryCode) {
        case 'AU':
          return true;
        default:
          switch (itemType) {
            case ItemType.APPOINTMENTS_SERVICE:
              return false;
            default:
              return true;
          }
      }
    }
    const taxable = getDefaultTaxableValueForItemType(userInfo.countryCode, itemType);
    const createOptions = {
      taxable
    };
    if (itemType) {
      createOptions.type = itemType;
    }
    const newObject = store.createRecord('item', createOptions);
    if (!isNone(merchantSubunits)) {
      newObject.addMerchantSubunits(merchantSubunits);
    }
    return newObject;
  }
  static catalogType() {
    return 'ITEM';
  }
  get imageSortProperties() {
    return ['ordinal'];
  }
  get primaryImage() {
    return this.images.firstObject;
  }
  get itemAndVariationImages() {
    const images = [...this.images];
    this.sellableVariations.forEach(variation => {
      images.addObjects(variation.images);
    });
    return images.filter(Boolean);
  }
  get membershipsByModifierList() {
    return this.itemItemModifierListMemberships.reduce((map, membership) => {
      map.set(membership.modifierList, membership);
      return map;
    }, new Map());
  }
  get isDonation() {
    return this.type === ItemType.DONATION;
  }
  get isEventType() {
    return this.type === ItemType.EVENT;
  }
  // An item is taxable unless `taxable` is explicitly set to `false`
  get isTaxable() {
    return this.taxable !== false;
  }
  get isDirty() {
    if (this.menuCategory?.isDirty) {
      return true;
    }
    if ((this.itemVariations || []).any(o => o && o.isDirty) || (this.itemItemModifierListMemberships || []).any(o => o && o.isDirty) || (this.itemFeeMemberships || []).any(o => o && o.isDirty) || (this.comboSlots || []).any(o => o && o.isDirty)) {
      return true;
    }
    return super.isDirty;
  }
  setKitchenCategories(newKitchenCategories) {
    const existingKitchenCategoryIds = new Set(this.kitchenCategories.map(({
      categoryId
    }) => categoryId));
    const nowSelectedCategoryIds = new Set(newKitchenCategories.map(({
      categoryId
    }) => categoryId));
    const deselectedCategoryIds = new Set([...existingKitchenCategoryIds].filter(existingId => !nowSelectedCategoryIds.has(existingId)));
    newKitchenCategories.filter(({
      categoryId: newCategoryId
    }) => !existingKitchenCategoryIds.has(newCategoryId)).forEach(({
      categoryId
    }) => {
      this.additionalCategories.pushObject(this.store.createFragment('category-membership', {
        categoryId
      }));
    });
    this.additionalCategories.filter(membership => deselectedCategoryIds.has(membership.categoryId)).forEach(membership => {
      this.additionalCategories.removeObject(membership);
    });
  }

  // If menuCategory is set directly, then it does not dirty the model.
  watchAndSetCategory(category) {
    this.watchRelationship('menuCategory', () => this.menuCategory = category);
  }
  rollbackRelationships() {
    super.rollbackRelationships();
    this.itemVariations?.forEach(o => o.rollbackRelationships());
    this.comboSlots?.forEach(o => o.rollbackRelationships());
  }
  rollbackAttributes(rollbackRelationships = true) {
    super.rollbackAttributes();
    if (rollbackRelationships) {
      this.itemVariations?.forEach(o => o.rollbackAttributes());
      this.itemItemModifierListMemberships?.forEach(o => o.rollbackAttributes());
      this.itemFeeMemberships?.forEach(o => o.rollbackAttributes());
      this.comboSlots?.forEach(o => o?.rollbackAttributes());
    }
  }
  get displayVariations() {
    return this.actualItemVariations?.length === 0 ? this.intl.t('items.displayPrice.variable') : this.intl.t('items.itemLibrary.priceVariations', {
      count: this.actualItemVariations?.length
    });
  }
  get displayModifiers() {
    return this.itemItemModifierListMemberships.map(modifierListMembership => {
      return {
        name: modifierListMembership.modifierListFormattedName,
        options: modifierListMembership.actualItemModifierOptionNames,
        enabled: modifierListMembership.enabled,
        subunits: modifierListMembership.modifierListSubunitTokens
      };
    });
  }
  get listBasedDisplayModifiers() {
    const listModifierMemberships = this.itemItemModifierListMemberships.filter(membership => membership.modifierList && isListModifierType(membership.modifierListType));
    return listModifierMemberships.map(modifierListMembership => {
      return {
        name: modifierListMembership.modifierListFormattedName,
        options: modifierListMembership.actualItemModifierOptionNames,
        enabled: modifierListMembership.enabled,
        subunits: modifierListMembership.modifierListSubunitTokens
      };
    });
  }
  get variationMerchantCustomAttributeDefinitions() {
    return this.variationMerchantCustomAttributeDefinitionArrays.reduce((variationMerchantCustomAttributeDefinitions, currentArray) => variationMerchantCustomAttributeDefinitions.addObjects(currentArray), []);
  }
  trimNameAndSku() {
    const name = this.name;
    if (isPresent(name)) {
      const trimmedName = name.trim();
      this.name = trimmedName;
    }
    this.itemVariations.rejectBy('isDeleted').forEach(variation => {
      variation.trimNameAndSku();
    });
  }
  get subunitsWithInventoryTracking() {
    const subunits = A();
    this.actualItemVariations.forEach(variation => {
      variation.get('subunits').forEach(subunit => {
        if (variation.getUnitOverride(subunit.get('token'), 'track_inventory') === true) {
          subunits.addObject(subunit);
        }
      });
    });
    return subunits;
  }

  /**
   * Includes all variations of the item
   * In the case of retail unsubscription, we filter out non-stockable variations
   */
  get nonDeletedNonPlaceholderVariations() {
    let variations = this.itemVariations;
    if (!this.userSubscriptions.canUseAdvancedInventory) {
      variations = variations.filter(variation => variation.isStockable || variation.isBundle || this.userSubscriptions.canUseRecipes && variation.recipe);
    }
    return variations.filter(variation => !variation.isPlaceholder && !variation.isDeleted).sort((v1, v2) => v1?.ordinal - v2?.ordinal);
  }
  get stockByVariations() {
    return this.nonDeletedNonPlaceholderVariations.filter(itemVariation => !isEmpty(itemVariation.derivedSellByVariations));
  }
  get sellableVariations() {
    return this.nonDeletedNonPlaceholderVariations.filter(v => v.isSellable).sort((v1, v2) => v1?.ordinal - v2?.ordinal);
  }
  /**
   * Includes variations which have non-deleted components or composition
   */
  get componentInventoryVariations() {
    return this.nonDeletedNonPlaceholderVariations.filter(variation => !isEmpty(variation.components.filter(component => {
      if (component.belongsTo('composition').value() !== null) {
        return !component.isDeleted && component.composition?.compositionType !== 'FIXED_COMPOSITION';
      }
      return !component.isDeleted;
    })) || !isNone(variation.composition) && !variation.composition.isDeleted && !variation.isBundle);
  }
  get nonComponentInventoryVariations() {
    return this.nonDeletedNonPlaceholderVariations.filter(variation => !this.componentInventoryVariations.includes(variation));
  }
  get hasStockByVariations() {
    return !isEmpty(this.stockByVariations);
  }
  get donationAmounts() {
    return this.type === ItemType.DONATION ? this.actualItemVariations.filter(variation => variation.pricingType === PricingType.FIXED_PRICING) : [];
  }
  get shouldAllowCustomDonationAmount() {
    return this.actualItemVariations.some(variation => {
      return variation.pricingType === PricingType.VARIABLE_PRICING;
    });
  }
  get trackedInventoryVariations() {
    return this.actualItemVariations.filter(variation => {
      const unitTokens = variation.get('subunits').mapBy('token');
      for (let i = 0; i < unitTokens.get('length'); i++) {
        if (variation.getUnitOverride(unitTokens[i], 'track_inventory') === true) {
          return true;
        }
      }
      return false;
    });
  }
  get hasRecipe() {
    return this.userSubscriptions.canUseRecipes && this.actualItemVariations.some(itemVariation => Boolean(itemVariation.recipe));
  }
  lowInventoryVariationsAtSubunit(unitToken) {
    return this.actualItemVariations.filter(variation => {
      return variation.inventoryTrackingAndAlertsEnabledAtSubunit(unitToken) && variation.inventoryIsLowAtSubunit(unitToken);
    });
  }
  outOfStockVariationsAtSubunit(unitToken) {
    return this.actualItemVariations.filter(variation => {
      return variation.inventoryTrackingAndAlertsEnabledAtSubunit(unitToken) && variation.inventoryIsOutAtSubunit(unitToken);
    });
  }

  // These 5 functions override multi-unit support functions so we can add/remove the subunits
  // from the multi-unit variations which in turn add/remove them from the item variations themselves
  // These cascade the enabled property when you add a subunit
  addMerchantSubunit(merchantSubunit) {
    this.addMerchantSubunits([merchantSubunit]);
  }
  addMerchantSubunits(merchantSubunits) {
    if (merchantSubunits.length > 0) {
      super.addMerchantSubunits(merchantSubunits);
      const image = this.image;
      if (!isNone(image)) {
        image.addMerchantSubunits(merchantSubunits);
      }
      this.itemVariations.rejectBy('isDeleted').forEach(variation => {
        variation.addMerchantSubunits(merchantSubunits);
      });
      this.itemItemModifierListMemberships?.rejectBy('isDeleted').forEach(membership => {
        const enableSubunits = merchantSubunits.filter(subunit => membership.get('modifierList').enabledForUnit(subunit.get('token')));
        membership.addMerchantSubunits(enableSubunits);
      });
      this.itemFeeMemberships?.rejectBy('isDeleted').forEach(membership => {
        const enableSubunits = merchantSubunits.filter(subunit => membership.get('fee').enabledForUnit(subunit.get('token')));
        membership.addMerchantSubunits(enableSubunits);
      });
    }
  }

  // This function cascades the enabled property when you remove a subunit
  removeMerchantSubunit(subunitToken) {
    super.removeMerchantSubunit(subunitToken);
    const image = this.image;
    if (!isNone(image)) {
      image.removeMerchantSubunit(subunitToken);
    }
    this.itemVariations.rejectBy('isDeleted').forEach(variation => variation.removeMerchantSubunit(subunitToken));
    this.itemItemModifierListMemberships.rejectBy('isDeleted').forEach(membership => membership.removeMerchantSubunit(subunitToken));
    this.itemFeeMemberships.rejectBy('isDeleted').forEach(membership => membership.removeMerchantSubunit(subunitToken));
  }

  // This function cascades when you change the global enabled property
  updateGloballyEnabledForRelationships(globallyEnabled) {
    const image = this.image;
    if (!isNone(image)) {
      image.set('globallyEnabled', globallyEnabled);
    }
    this.itemVariations.rejectBy('isDeleted').forEach(variation => variation.set('globallyEnabled', globallyEnabled));
    this.itemItemModifierListMemberships.rejectBy('isDeleted').forEach(membership => {
      if (!globallyEnabled || membership.get('modifierList.globallyEnabled')) {
        membership.set('globallyEnabled', globallyEnabled);
      }
      membership.setMerchantSubunits(this.commonSubunits(membership.get('modifierList')));
    });
    this.itemFeeMemberships.rejectBy('isDeleted').forEach(membership => {
      if (!globallyEnabled || membership.get('fee.globallyEnabled')) {
        membership.set('globallyEnabled', globallyEnabled);
      }
      membership.setMerchantSubunits(this.commonSubunits(membership.get('fee')));
    });
  }

  // This function removes ItemFeeMemberships that are no longer in the intersection of units
  // where taxes and items are enabled.
  removeAffectedRelatedObjects(subunitToken) {
    const itemTypes = ItemTypesForFiltering_V3;
    if (isNone(this.type) || itemTypes.includes(this.type)) {
      const relevantTokens = this.subunits.mapBy('token');
      const relevanceFilter = this.filterByAffectedBySubunit(subunitToken, relevantTokens);
      this.store.findAll('fee').then(taxes => {
        const relevantTaxes = taxes.filter(relevanceFilter);
        relevantTaxes.forEach(tax => {
          this.removeFeeMembership(tax);
        });
      });
    }
  }

  // This function creates new ItemFeeMemberships at the intersection of units where taxes and
  // items are enabled.
  addAffectedRelatedObjects(_subunitToken) {
    // TODO: remove all calls to this useless function, and remove it itself
  }

  /**
   * Fees / Taxes
   */
  get totalInclusiveFeesPercentage() {
    return this.itemFeeMemberships.rejectBy('isDeleted', true).filterBy('fee.inclusionType', this.store.modelFor('fee').InclusionType.INCLUSIVE).reduce((sum, itemFeeMembership) => sum + itemFeeMembership.get('fee.percentage'), 0);
  }
  itemFeeMembershipForFee(fee) {
    return isPresent(fee.get('id')) ? this.itemFeeMemberships.findBy('fee.id', fee.get('id')) : this.itemFeeMemberships.findBy('fee', fee);
  }
  addFeeMembership(fee) {
    if (isPresent(fee.productSet) && !fee.productSet.isDeleted) {
      captureItemFeeMembershipConstraint(this.id, fee.id);
      return null;
    }
    let membership = this.itemFeeMembershipForFee(fee);
    if (membership) {
      membership.rollbackAttributes();
    } else {
      membership = this.store.createRecord('item-fee-membership', {
        fee
      });
      membership.set('globallyEnabled', this.globallyEnabled && fee.get('globallyEnabled'));
      membership.setMerchantSubunits(this.commonSubunits(fee));
      this.watchRelationship('itemFeeMemberships', () => {
        this.itemFeeMemberships.pushObject(membership);
      });
    }
    return membership;
  }
  removeFeeMembership(fee) {
    const membership = this.itemFeeMembershipForFee(fee);
    return this.removeItemFeeMembership(membership);
  }
  removeItemFeeMembership(membership) {
    if (membership) {
      this.watchRelationship('itemFeeMemberships', () => {
        membership.deleteRecord();
      });
    }
    return membership;
  }

  /**
   * Modifiers
   */

  itemModifierMembershipForModifier(modifierList) {
    return isPresent(modifierList.get('id')) ? this.itemItemModifierListMemberships.findBy('modifierList.id', modifierList.get('id')) : this.itemItemModifierListMemberships.findBy('modifierList', modifierList);
  }
  insertMembershipForModifier(modifierList) {
    let membership;
    this.watchRelationship('itemItemModifierListMemberships', () => {
      membership = this.store.createRecord('item-item-modifier-list-membership', {
        item: this,
        modifierList
      });
    });
    membership.set('globallyEnabled', this.globallyEnabled && modifierList.globallyEnabled);
    membership.setMerchantSubunits(this.commonSubunits(modifierList));
    return membership;
  }
  insertModifierMembership(membership) {
    if (!membership.get('enabled')) {
      membership.set('enabled', true);
    }
    if (membership.get('id') && membership.isDeleted && !isNone(this.itemItemModifierListMemberships.findBy('id', membership.get('id')))) {
      membership.rollbackAttributes();
    } else {
      this.watchRelationship('itemItemModifierListMemberships', () => {
        this.itemItemModifierListMemberships.pushObject(membership);
      });
    }
  }
  removeModifierMembership(membership) {
    if (!membership) {
      return;
    }
    if (membership.get('isNew')) {
      this.watchRelationship('itemItemModifierListMemberships', () => {
        membership.unloadRecord();
      });
    } else {
      membership.set('enabled', false);
    }
  }
  get listTypeItemModifierMemberships() {
    return this.itemItemModifierListMemberships.filter(membership => isListModifierType(membership.get('modifierList').modifierType));
  }

  /**
   * Decorators
   */
  get displayAbbreviation() {
    if (this._displayAbbreviation !== undefined) {
      return this._displayAbbreviation;
    }
    const abbreviation = this.abbreviation;
    const name = this.name;
    return abbreviation || (!isNone(name) ? name.slice(0, 2) : null);
  }
  set displayAbbreviation(value) {
    set(this, '_displayAbbreviation', value);
  }
  get displayPrice() {
    const variations = this.sellableVariations;
    if (variations.length === 1) {
      const variation = variations.firstObject;
      return variation.priceRange;
    } else {
      return this.intl.t('items.displayPrice.numPrices', {
        count: variations.length
      });
    }
  }
  get displayPriceWithUnit() {
    const variations = this.sellableVariations;
    return variations.length === 1 ? variations.firstObject.priceRangeWithUnit : this.intl.t('items.displayPrice.numPrices', {
      count: variations.length
    });
  }

  // display a range of prices from all of the item's variations
  get displayPriceRange() {
    return this.getDisplayPriceRangeForUnits(this.subunits);
  }
  getDisplayPriceRangeForUnits(units, filteredVariations = this.sellableVariations, measurementUnitsAbbreviations = new Set(), displayMeasurementUnitAbbreviation = false) {
    let max;
    let isVariable;
    let min = max = isVariable = null;
    const uniquePrices = new Set();
    filteredVariations.forEach(variation => {
      let hasUnitWithoutOverrides = isEmpty(units);
      const measurementUnitId = variation.measurementUnit ? variation.measurementUnit.id : '';
      units.forEach(unit => {
        const priceOverride = variation.getUnitOverride(unit.token, 'price');
        if (!isNone(priceOverride)) {
          if (isNone(priceOverride.currency_code)) {
            priceOverride.currency_code = this.userInfo.currencyCode;
          }
          const priceMoney = Money.create({
            amount: priceOverride.cents,
            currencyCode: priceOverride.currency_code ?? this.userInfo.currencyCode
          });
          const poAmount = priceOverride.amount;
          if (isNone(poAmount)) {
            isVariable = true;
          } else {
            if (isNone(min) || poAmount < min.amount) {
              min = priceMoney;
            }
            if (isNone(max) || poAmount > max.amount) {
              max = priceMoney;
            }
            uniquePrices.add(`${poAmount}: ${measurementUnitId}`);
          }
        } else {
          hasUnitWithoutOverrides = true;
        }
      });
      if (hasUnitWithoutOverrides) {
        const price = variation.price ? variation.price.amount : undefined;
        if (!isVariable && variation.isVariablePriced) {
          isVariable = true;
          return;
        } else if (!price) {
          return;
        }
        if (isNone(min) || price < min.amount) {
          min = variation.price;
        }
        if (isNone(max) || price > max.amount) {
          max = variation.price;
        }
        uniquePrices.add(`${price}: ${measurementUnitId}`);
      }
    });

    // String selection
    if (isVariable) {
      return this.intl.t('items.displayPrice.variable');
    } else {
      if (measurementUnitsAbbreviations.size > 1) {
        return this.intl.t('items.displayPrice.numPrices', {
          count: uniquePrices.size
        });
      }
      const measurementUnitAbbreviation = displayMeasurementUnitAbbreviation ? measurementUnitsAbbreviations.values().next().value : '';
      if (!isNone(min)) {
        if (min.amount === max.amount) {
          return measurementUnitAbbreviation ? this.intl.t('items.displayPrice.exactMeasurement', {
            price: min.formatted,
            measurementUnitAbbreviation
          }) : min.formatted;
        } else {
          return measurementUnitAbbreviation ? this.intl.t('items.displayPrice.rangeMeasurement', {
            min: min.formatted,
            max: max.formatted,
            measurementUnitAbbreviation
          }) : this.intl.t('items.displayPrice.range', {
            min: min.formatted,
            max: max.formatted
          });
        }
      } else {
        return this.intl.t('items.displayPrice.free');
      }
    }
  }
  get variationOptionValuesByOptionId() {
    // Use a plain JS object so that its properties can be fetched via the "get" handlebars helper
    const valueMap = {};
    if (isNone(this.itemOptions)) {
      return valueMap;
    }
    this.itemOptions.forEach(option => {
      valueMap[option.idOrTempId()] = [];
    });
    this.itemVariations.filter(variation => !variation.isDeleted).forEach(variation => {
      variation.itemOptionValuesByOptionId.forEach((optionValue, itemOptionId) => {
        // NB(cclegg): The catalog data in some tests isn't quite set up correctly - the item and its variations
        // should have both item option and value attributes. However, we don't know the server generated tokens at this point,
        // so instead we are creating objects with all of the normal attributes and we check against the expected
        // option/values tokens generated in the fake upsert endpoint.
        if (isNone(valueMap[itemOptionId])) {
          Logger.error(`Item has variation with option value not belonging to an option on the item. Missing option id: ${itemOptionId}`);
        } else {
          valueMap[itemOptionId].addObject(optionValue);
        }
      });
    });
    this.itemOptions.forEach(option => {
      valueMap[option.idOrTempId()] = valueMap[option.idOrTempId()].sortBy('ordinal');
    });
    return valueMap;
  }
  get allOptionValuesByOptionId() {
    // Return a plain JS object so that its properties can be fetched via the "get" handlebars helper

    return (this.itemOptions || []).reduce((valueMap, option) => {
      valueMap[option.idOrTempId()] = [...(option.values.toArray() || []), ...(this.variationOptionValuesByOptionId[option.idOrTempId()] || [])].uniq().sortBy('ordinal');
      return valueMap;
    }, {});
  }
  get nextOrdinalByOptionId() {
    // Return a plain JS object so that its properties can be fetched via the "get" handlebars helper
    return (this.itemOptions || []).reduce((ordinalMap, itemOption) => {
      const allOptionValues = [...(itemOption.values.toArray() || []), ...this.variationOptionValuesByOptionId[itemOption.idOrTempId()]];
      ordinalMap[itemOption.idOrTempId()] = Math.max(...allOptionValues.mapBy('ordinal').compact()) + 1;
      return ordinalMap;
    }, {});
  }
  get isBundle() {
    return this.actualItemVariations.any(variation => variation.isBundle);
  }
  get isRecipe() {
    if (!this.userSubscriptions.canUseRecipes) {
      return false;
    }
    return this.actualItemVariations.any(variation => variation.recipe);
  }

  // --------------------------------------------------------
  // Item Type related
  // --------------------------------------------------------
  get isPhysicalOrFoodAndBevItem() {
    return this.type === ItemType.REGULAR || this.type === ItemType.FOOD_AND_BEV;
  }
  get isFoodAndBev() {
    return this.type === ItemType.FOOD_AND_BEV;
  }
  get foodAndBevIngredientValues() {
    return this.foodAndBevIngredients.map(i => i.value);
  }
  get foodAndBevDietaryPreferenceValues() {
    return this.foodAndBevDietaryPreferences.map(i => i.value);
  }
  static createTestRecord(store, properties = {}) {
    assert('`Item.createTestRecord()` should only be used in a test environment. Use `this.store.createRecord(...)` in production code.', environment().isTesting);
    if (!environment().isTesting) {
      return null;
    }
    const createProperties = {
      ...properties
    };
    if (!properties.type) {
      createProperties.type = 'REGULAR';
    }
    return store.createRecord(this._modelNameForMigration, createProperties);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'item'), _defineProperty(_class2, "sortKey", 'name'), _defineProperty(_class2, "VisibilityType", VisibilityType), _defineProperty(_class2, "EcomVisibility", EcomVisibility), _defineProperty(_class2, "MAX_NAME_LENGTH", MAX_NAME_LENGTH), _defineProperty(_class2, "MAX_SKU_LENGTH", MAX_SKU_LENGTH), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "ageRestriction", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "availableOnline", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "availableForPickup", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "availableElectronically", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "buyerFacingName", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "htmlDescription", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "sortName", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "kitchenName", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "taxable", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "visibility", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "ecomAvailable", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "ecomVisibility", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoPermalink", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoPageTitle", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoPageDescription", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "openGraphLinkTitle", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "openGraphLinkDescription", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "ecomBuyButtonText", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "ecomUri", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "skipsModifierScreen", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "comboSlots", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "customAttributes", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "shippingFulfillmentPreferencesId", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "pickupFulfillmentPreferencesId", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "deliveryFulfillmentPreferencesId", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "dineInFulfillmentPreferencesId", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "posDisplayName", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "ecomAllowOrderItemQuantities", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "ecomOrderItemMaxQuantity", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "requiresSubscriptionToSell", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "customShippingBoxId", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "menuCategory", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "additionalCategories", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "itemVariations", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "onlineStoreItemData", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "imageMemberships", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "itemItemModifierListMemberships", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "itemFeeMemberships", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "itemOptions", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "isArchived", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "imageSortProperties", [_dec48], Object.getOwnPropertyDescriptor(_class.prototype, "imageSortProperties"), _class.prototype), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "sortedImageMemberships", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "images", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "primaryImage", [_dec51], Object.getOwnPropertyDescriptor(_class.prototype, "primaryImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemAndVariationImages", [_dec52], Object.getOwnPropertyDescriptor(_class.prototype, "itemAndVariationImages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "membershipsByModifierList", [_dec53], Object.getOwnPropertyDescriptor(_class.prototype, "membershipsByModifierList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDonation", [_dec54], Object.getOwnPropertyDescriptor(_class.prototype, "isDonation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEventType", [_dec55], Object.getOwnPropertyDescriptor(_class.prototype, "isEventType"), _class.prototype), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "hasMultipleVariations", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isTaxable", [_dec57], Object.getOwnPropertyDescriptor(_class.prototype, "isTaxable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec58], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "kitchenCategories", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "isAvailableOnline", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "isSinglePriced", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "displayVariations", [_dec62], Object.getOwnPropertyDescriptor(_class.prototype, "displayVariations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayModifiers", [_dec63], Object.getOwnPropertyDescriptor(_class.prototype, "displayModifiers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "listBasedDisplayModifiers", [_dec64], Object.getOwnPropertyDescriptor(_class.prototype, "listBasedDisplayModifiers"), _class.prototype), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "variationMerchantCustomAttributeDefinitionArrays", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "variationMerchantCustomAttributeDefinitions", [_dec66], Object.getOwnPropertyDescriptor(_class.prototype, "variationMerchantCustomAttributeDefinitions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subunitsWithInventoryTracking", [_dec67], Object.getOwnPropertyDescriptor(_class.prototype, "subunitsWithInventoryTracking"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nonDeletedNonPlaceholderVariations", [_dec68], Object.getOwnPropertyDescriptor(_class.prototype, "nonDeletedNonPlaceholderVariations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stockByVariations", [_dec69], Object.getOwnPropertyDescriptor(_class.prototype, "stockByVariations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sellableVariations", [_dec70], Object.getOwnPropertyDescriptor(_class.prototype, "sellableVariations"), _class.prototype), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "notForSaleVariations", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "componentInventoryVariations", [_dec72], Object.getOwnPropertyDescriptor(_class.prototype, "componentInventoryVariations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nonComponentInventoryVariations", [_dec73], Object.getOwnPropertyDescriptor(_class.prototype, "nonComponentInventoryVariations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasStockByVariations", [_dec74], Object.getOwnPropertyDescriptor(_class.prototype, "hasStockByVariations"), _class.prototype), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "actualItemVariations", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "donationAmounts", [_dec76], Object.getOwnPropertyDescriptor(_class.prototype, "donationAmounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldAllowCustomDonationAmount", [_dec77], Object.getOwnPropertyDescriptor(_class.prototype, "shouldAllowCustomDonationAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackedInventoryVariations", [_dec78], Object.getOwnPropertyDescriptor(_class.prototype, "trackedInventoryVariations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasRecipe", [_dec79], Object.getOwnPropertyDescriptor(_class.prototype, "hasRecipe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalInclusiveFeesPercentage", [_dec80], Object.getOwnPropertyDescriptor(_class.prototype, "totalInclusiveFeesPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "listTypeItemModifierMemberships", [_dec81], Object.getOwnPropertyDescriptor(_class.prototype, "listTypeItemModifierMemberships"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayAbbreviation", [_dec82], Object.getOwnPropertyDescriptor(_class.prototype, "displayAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayPrice", [_dec83], Object.getOwnPropertyDescriptor(_class.prototype, "displayPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayPriceWithUnit", [_dec84], Object.getOwnPropertyDescriptor(_class.prototype, "displayPriceWithUnit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayPriceRange", [_dec85], Object.getOwnPropertyDescriptor(_class.prototype, "displayPriceRange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "variationOptionValuesByOptionId", [_dec86], Object.getOwnPropertyDescriptor(_class.prototype, "variationOptionValuesByOptionId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allOptionValuesByOptionId", [_dec87], Object.getOwnPropertyDescriptor(_class.prototype, "allOptionValuesByOptionId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextOrdinalByOptionId", [_dec88], Object.getOwnPropertyDescriptor(_class.prototype, "nextOrdinalByOptionId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBundle", [_dec89], Object.getOwnPropertyDescriptor(_class.prototype, "isBundle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRecipe", [_dec90], Object.getOwnPropertyDescriptor(_class.prototype, "isRecipe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPhysicalOrFoodAndBevItem", [_dec91], Object.getOwnPropertyDescriptor(_class.prototype, "isPhysicalOrFoodAndBevItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFoodAndBev", [_dec92], Object.getOwnPropertyDescriptor(_class.prototype, "isFoodAndBev"), _class.prototype), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "foodAndBevCalorieCount", [_dec93], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "foodAndBevIngredients", [_dec94], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "foodAndBevIngredientValues", [_dec95], Object.getOwnPropertyDescriptor(_class.prototype, "foodAndBevIngredientValues"), _class.prototype), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "foodAndBevDietaryPreferences", [_dec96], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "foodAndBevDietaryPreferenceValues", [_dec97], Object.getOwnPropertyDescriptor(_class.prototype, "foodAndBevDietaryPreferenceValues"), _class.prototype)), _class));
export { Item as default };
/* eslint-enable ember/no-assignment-of-untracked-properties-used-in-tracking-contexts */